"use client";

import { ExternalLink, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Location() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: mapRef,
    isVisible: mapVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: metaRef,
    isVisible: metaVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const metadata = [{
    label: "OBSZAR DZIAŁANIA",
    value: "Całe województwo śląskie"
  }, {
    label: "DYSPOZYCYJNOŚĆ",
    value: "Poniedziałek - Piątek 7:00-18:00"
  }, {
    label: "WSPARCIE",
    value: "Bezpłatna wycena inwestycji"
  }];
  const mapsUrl = "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent("Katowice, województwo śląskie");
  return <section data-section-id="4077" id="obszar-działania" className="bg-background text-foreground py-20 md:py-28 lg:py-32 overflow-hidden">
      {}
      <div ref={headerRef} className={`max-w-4xl mx-auto px-6 md:px-8 text-center mb-12 md:mb-16 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <p className="font-default text-xs md:text-sm tracking-[0.3em] text-secondary uppercase mb-6">
          Lokalizacja
        </p>
        <h2 className="font-default text-4xl md:text-5xl lg:text-[3.5rem] leading-tight text-foreground font-bold" style={{
        letterSpacing: "-0.02em"
      }}>
          Kompleksowe usługi budowlane na terenie{" "}
          <span className="text-primary">Śląska</span>.
        </h2>
      </div>

      {}
      <div ref={mapRef} className={`w-full px-0 md:px-8 lg:px-12 mb-0 transition-all duration-1000 ease-out ${mapVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="relative w-full border-y md:border border-border overflow-hidden rounded-lg">
          <div className="relative w-full" style={{
          aspectRatio: "16 / 7"
        }}>
            {}
            <div className="absolute inset-0 bg-slate-100">
              {}
              <svg className="absolute inset-0 w-full h-full" viewBox="0 0 1600 700" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
                {}
                <path d="M 0 480 Q 200 460 400 490 T 800 500 Q 1000 510 1200 485 T 1600 495 L 1600 700 L 0 700 Z" fill="hsl(210 10% 90%)" opacity="0.85" />
                <path d="M 1100 0 Q 1150 100 1180 200 Q 1210 320 1250 380 L 1280 380 Q 1240 280 1220 180 Q 1200 80 1180 0 Z" fill="hsl(210 10% 90%)" opacity="0.85" />

                {}
                <g stroke="hsl(210 10% 25%)" strokeWidth="1.5" fill="none" opacity="0.5">
                  <path d="M 0 200 L 1600 220" />
                  <path d="M 0 350 Q 400 340 800 360 T 1600 370" />
                  <path d="M 200 0 L 220 700" />
                  <path d="M 600 0 Q 620 200 640 400 T 660 700" />
                  <path d="M 900 0 L 920 700" />
                  <path d="M 1300 0 Q 1280 250 1310 500 T 1320 700" />
                  <path d="M 0 100 L 1600 110" strokeWidth="0.8" />
                  <path d="M 0 280 L 1600 295" strokeWidth="0.8" />
                  <path d="M 0 420 L 1100 435" strokeWidth="0.8" />
                  <path d="M 400 0 L 410 480" strokeWidth="0.8" />
                  <path d="M 750 0 L 760 700" strokeWidth="0.8" />
                  <path d="M 1100 0 L 1110 480" strokeWidth="0.8" />
                </g>
              </svg>

              {}
              <div className="absolute inset-0 opacity-30 mix-blend-overlay pointer-events-none" style={{
              backgroundImage: "radial-gradient(hsl(210 10% 25% / 0.1) 1px, transparent 1px)",
              backgroundSize: "50px 50px"
            }} aria-hidden="true" />
            </div>

            {}
            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
              {}
              <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-lg" style={{
              width: "160px",
              height: "160px",
              background: "radial-gradient(circle, hsl(205 95% 50% / 0.35) 0%, hsl(205 95% 50% / 0.08) 40%, transparent 70%)",
              animation: "flarePulse 3s ease-in-out infinite"
            }} aria-hidden="true" />
              {}
              <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-lg border border-primary" style={{
              width: "48px",
              height: "48px",
              animation: "flareRing 3s ease-out infinite"
            }} aria-hidden="true" />
              {}
              <div className="relative flex flex-col items-center">
                <div className="flex items-center justify-center w-10 h-10 bg-primary text-white shadow-lg" style={{
                borderRadius: "2px"
              }}>
                  <MapPin className="size-4" strokeWidth={2.5} />
                </div>
                <div className="w-1 h-1 bg-primary mt-0.5 shadow-lg" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {}
      <div ref={metaRef} className={`max-w-6xl mx-auto px-6 md:px-8 mt-12 md:mt-16 transition-all duration-1000 ease-out delay-200 ${metaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-0">
          {metadata.map((item, i) => <div data-index={i} key={item.label} className={`flex flex-col items-center text-center px-4 md:px-8 ${i > 0 ? "md:border-l md:border-border" : ""}`}>
              <p className="font-default text-[0.65rem] md:text-xs tracking-[0.25em] text-secondary uppercase mb-3 font-semibold">
                {item.label}
              </p>
              <p className="font-default text-lg md:text-xl text-foreground leading-snug font-medium">
                {item.value}
              </p>
            </div>)}
        </div>

        {}
        <div className="flex justify-center mt-12 md:mt-16">
          <Button asChild variant="ghost" className="group font-default text-xs md:text-sm tracking-[0.25em] uppercase text-white bg-primary hover:bg-primary/90 h-12 px-8 transition-all duration-300 rounded-lg">
            <Link to="/ContactPage">
              Umów wizytę na budowie
              <ExternalLink className="size-3.5 ml-1 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-0.5" />
            </Link>
          </Button>
        </div>
      </div>

      <style>{`
        @keyframes flarePulse {
          0%, 100% {
            opacity: 0.5;
            transform: translate(-50%, -50%) scale(0.85);
          }
          50% {
            opacity: 1;
            transform: translate(-50%, -50%) scale(1.1);
          }
        }
        @keyframes flareRing {
          0% {
            opacity: 0.8;
            transform: translate(-50%, -50%) scale(0.6);
          }
          100% {
            opacity: 0;
            transform: translate(-50%, -50%) scale(2);
          }
        }
      `}</style>
    </section>;
}